import { NgModule } from '@angular/core'
import { ApprowGuardComponent } from './approw-guard.component'

@NgModule({
  declarations: [ApprowGuardComponent],
  imports: [],
  exports: [ApprowGuardComponent],
})
export class ApprowGuardModule {}
